/**
 * Utility to convert base64 data URLs to Blobs and handle PDF/image preview & download safely.
 * Solves the issue where modern browsers block top-frame navigation to data: URLs.
 */

export function dataUrlToBlob(dataUrl) {
  if (!dataUrl || typeof dataUrl !== 'string') return null;
  if (!dataUrl.startsWith('data:')) return null;

  try {
    const parts = dataUrl.split(';base64,');
    if (parts.length < 2) return null;

    const contentType = parts[0].replace('data:', '') || 'application/pdf';
    const byteCharacters = atob(parts[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  } catch (err) {
    console.error('Erro ao converter dataUrl para Blob:', err);
    return null;
  }
}

export function getBlobUrl(fileUrl) {
  if (!fileUrl) return null;
  if (fileUrl.startsWith('data:')) {
    const blob = dataUrlToBlob(fileUrl);
    return blob ? URL.createObjectURL(blob) : null;
  }
  return fileUrl;
}

export function downloadFile(fileUrl, fileName = 'documento.pdf') {
  if (!fileUrl) return;

  try {
    if (fileUrl.startsWith('data:')) {
      const blob = dataUrlToBlob(fileUrl);
      if (!blob) {
        console.warn('Falha ao processar arquivo para download');
        return;
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName || 'documento.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 2000);
    } else {
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = fileName || 'documento.pdf';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  } catch (err) {
    console.error('Erro ao baixar arquivo:', err);
  }
}

export function openFileInNewTab(fileUrl, fileName = 'documento.pdf') {
  if (!fileUrl) return;

  try {
    if (fileUrl.startsWith('data:')) {
      const blob = dataUrlToBlob(fileUrl);
      if (!blob) {
        window.open(fileUrl, '_blank');
        return;
      }
      const blobUrl = URL.createObjectURL(blob);
      const win = window.open('', '_blank');
      if (win) {
        win.document.write(`
          <!DOCTYPE html>
          <html lang="pt-BR">
            <head>
              <meta charset="utf-8">
              <meta name="viewport" content="width=device-width, initial-scale=1">
              <title>${fileName || 'Visualizar Documento'}</title>
              <style>
                html, body {
                  margin: 0;
                  padding: 0;
                  width: 100%;
                  height: 100%;
                  overflow: hidden;
                  background-color: #525659;
                }
                iframe {
                  width: 100%;
                  height: 100%;
                  border: none;
                  display: block;
                }
              </style>
            </head>
            <body>
              <iframe src="${blobUrl}#toolbar=1" type="application/pdf" title="${fileName || 'Documento'}"></iframe>
            </body>
          </html>
        `);
        win.document.close();
      } else {
        downloadFile(fileUrl, fileName);
      }
    } else {
      window.open(fileUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (err) {
    console.error('Erro ao abrir arquivo em nova guia:', err);
    window.open(fileUrl, '_blank');
  }
}
